export default __webpack_public_path__ + "assets/85ad5b895446cff3b16d6080f0170418.svg";